module.exports = __webpack_public_path__ + "static/media/PDF_47.098e7854.pdf";